import _snakeCase from "lodash/snakeCase";
import _upperFirst from "lodash/upperFirst";
import _kebabCase from "lodash/kebabCase";
import _camelCase from "lodash/camelCase";
var CasingStyles = {
  Camel: 'camel',
  Snake: 'snake',
  Kebab: 'kebab',
  Pascal: 'pascal'
};
export default function applyCasingStyle(casingStyle, modelName) {
  switch (casingStyle) {
    case CasingStyles.Camel:
      return _camelCase(modelName);
    case CasingStyles.Kebab:
      return _kebabCase(modelName);
    case CasingStyles.Pascal:
      return _upperFirst(_camelCase(modelName));
    case CasingStyles.Snake:
      return _snakeCase(modelName);
    default:
      throw new Error("Illegal casingStyle of '".concat(casingStyle, "' provided. Must be one of [").concat([CasingStyles.Camel, CasingStyles.Kebab, CasingStyles.Pascal, CasingStyles.Snake], "]"));
  }
}